document.addEventListener('DOMContentLoaded', function() {
  var mainImg = document.getElementById('MainProductImage');
  if (!mainImg) return;

  var thumbs = document.querySelectorAll('.pdp-thumbs-item');

  thumbs.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var newSrc = btn.dataset.fullSrc;
      var newSrcset = btn.dataset.fullSrcset;
      var newAlt = btn.dataset.alt;

      if (newSrc) mainImg.src = newSrc;
      if (newSrcset) mainImg.srcset = newSrcset;
      if (newAlt) mainImg.alt = newAlt;

      thumbs.forEach(function(t) { t.classList.remove('active'); });
      btn.classList.add('active');
    });
  });
});

// Hover-pan zoom movement
document.addEventListener('DOMContentLoaded', function () {
  var container = document.querySelector('#pdp-main-img');
  var img = document.getElementById('MainProductImage');
  if (!container || !img) return;

  container.addEventListener('mousemove', function (e) {
    var rect = container.getBoundingClientRect();
    var x = ((e.clientX - rect.left) / rect.width) * 100;
    var y = ((e.clientY - rect.top) / rect.height) * 100;

    img.style.transformOrigin = x + '% ' + y + '%';
  });

  container.addEventListener('mouseleave', function () {
    img.style.transformOrigin = 'center center';
  });
});
